import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ToggleSwitchComponent } from '@pishgamrayan/ng-form-kit';
import { generateSecurePassword } from 'src/app/core/utils/secure-password-generator.util';

@Component({
    selector: 'password-generator',
    imports: [CommonModule, ToggleSwitchComponent],
    template: `
    <div>
      <toggle-switch
        label="messages.generateRandomPassword"
        (valueChange)="generatePassword($event)"
      ></toggle-switch>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordGeneratorComponent {
  @Output() password = new EventEmitter<string>();
  generatePassword(event) {
    let password = null;
    if (event) password = generateSecurePassword(10);
    this.password.emit(password);
  }
}
